import * as React from 'react';
import classnames from 'classnames';
import { Sizes, Star } from './Star.js';

const Stars = ({ className , rating: rating1 , count =5 , size =Sizes.large , color ,  })=>{
    const getFill = (index, rating)=>{
        const ratingMinusOffset = Math.max(0, rating - index);
        const fill = Math.min(1, Math.round(ratingMinusOffset * 10 / (0.5 * 10)) * 0.5);
        return fill;
    };
    const array = React.useMemo(()=>Array.from({
            length: count
        })
    , [
        count
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('store-rating-stars', className)
    }, array.map((_entry, index)=>/*#__PURE__*/ React.createElement(Star, {
            className: "store-rating-star",
            key: `star-${index}`,
            fill: getFill(index, rating1),
            size: size,
            color: color
        })
    ));
};
var Stars$1 = Stars;

export { Stars, Stars$1 as default };
//# sourceMappingURL=Stars.js.map
